export const id = {
    translation: {
        b: {
            cancel: 'Batalkan',
            confirm: 'Konfirmasi',
            send: 'Kirim',
            done: 'Selesai',
            close: 'Tutup',
            clear: 'Bersihkan',
            copy_link: 'Salin tautan',
            export: 'Ekspor',
            delete: 'Hapus',
            delete_confirm: 'Konfirmasi penghapusan',
            duplicate: 'Duplikat',
            share: 'Bagikan',
            sign_in: 'Masuk',
            sign_up: 'Daftar',
            email_address: 'Alamat email',
            yes: 'Ya',
            no: 'Tidak',
            back: 'Kembali',
            upgrade: 'Tingkatkan',
            remove: 'Hapus',
            restore: 'Pulihkan',
            archive: 'Arsipkan',
            rename: 'Ganti nama',
            leave: 'Keluar',
            import: 'Impor',
            continue: 'Lanjutkan',
            settings: 'Pengaturan',
            log_out: 'Keluar',
            invite: 'Undang',
            invited: 'Sudah diundang',
        },
        roles: {
            view: 'Penampil',
            comment: 'Pemberi komentar',
            edit: 'Editor',
            admin: 'Admin',
            owner: 'Pemilik',
            member: 'Anggota',
            remove: 'Hapus',
            more_roles: 'Peran lainnya...',
            change_role: 'Ubah peran...',
            remove_access: 'Hapus akses...',
            remove_invite: 'Hapus undangan...',
        },
        db_engine: {
            basic: 'SQL Dasar',
            general: 'SQL Umum',
        },
        socket_status: {
            reconnecting: 'Menghubungkan kembali...',
            offline: 'Anda sedang offline. Menghubungkan kembali...',
        },
        loader: {
            diagram: 'Memuat diagram...',
        },
        m_languages: {
            title: 'Bahasa',
            subtitle: 'Pilih bahasa'
        },
        m_feedback: {
            feature: {
                name: 'Permintaan fitur',
                desc: 'Ada fitur yang Anda butuhkan belum tersedia? Beri tahu kami — ide Anda penting'
            },
            feedback: {
                name: 'Bagikan umpan balik Anda',
                desc: 'Kami ingin sekali mendengar pendapat Anda'
            },
            support: {
                name: 'Dukungan',
                desc: 'Ada sesuatu yang tidak berfungsi? Beri tahu kami — kami akan segera memperbaikinya',
            },
            bug: {
                name: 'Laporkan masalah',
                desc: 'Ada sesuatu yang terlihat tidak beres? Laporkan — kami akan segera menanganinya',
            },
            integration: {
                name: 'Minta integrasi',
                desc: 'Umpan balik Anda sangat berarti bagi kami — tinggalkan catatan singkat',
            },
        },
        m_feedback_t: {
            feature: {
                name: 'Terima kasih atas saran Anda!',
                desc: 'Kami sangat menghargai waktu yang Anda luangkan untuk berbagi pemikiran — hal ini membantu kami menjadi lebih baik.'
            },
            feedback: {
                name: 'Terima kasih atas umpan balik Anda!',
                desc: 'Kami sangat menghargai waktu yang Anda luangkan untuk berbagi pemikiran — hal ini membantu kami menjadi lebih baik.'
            },
            support: {
                name: 'Terima kasih telah menghubungi kami!',
                desc: 'Terima kasih telah menghubungi dukungan — kami akan meninjau permintaan Anda dan merespons secepat mungkin.',
            },
            bug: {
                name: 'Terima kasih atas laporan Anda!',
                desc: 'Terima kasih telah melaporkan hal ini — ini membantu kami memperbaiki masalah lebih cepat dan terus meningkatkan pengalaman.',
            },
            contact: {
                name: 'Terima kasih telah menghubungi kami!',
                desc: 'Kami telah menerima pesan Anda dan akan merespons secepat mungkin.',
            },
            invite_people: {
                name: 'Undangan berhasil dikirim!',
                desc: 'Terima kasih telah menyebarkan kabar ini — kami senang bisa menyambut mereka.',
            },
            integration: {
                name: 'Terima kasih atas saran Anda!',
                desc: 'Kami sangat menghargai waktu yang Anda luangkan untuk berbagi pemikiran — hal ini membantu kami menjadi lebih baik.',
            },
        },
        m_diagram_details: {
            name_place: 'Masukkan nama proyek',
            desc_place: 'Masukkan deskripsi proyek'
        },
        m_quick_share: {
            title: 'Berbagi cepat',
            subtitle: '(Lewat tautan)'
        },
        m_export_img: {
            title: 'Ekspor gambar'
        },
        search_menu: {
            placeholder: 'Cari tabel, kolom, tipe...',
            hint: '',
            no_results: 'Tidak ada hasil',
            quick_results: 'Hasil cepat untuk',
            untitled: 'tanpa judul',
            command_tag: 'perintah',
            section_tables: 'Tabel',
            section_columns: 'Kolom',
            section_canvas: 'Kanvas',
            section_export: 'Ekspor',
            section_preferences: 'Preferensi',
            section_settings: 'Pengaturan',
            type_table: 'tabel',
            type_note: 'catatan',
            cmd_new_table: 'Buat tabel baru...',
            cmd_new_note: 'Buat catatan baru...',
            cmd_new_line: 'Buat garis baru...',
            cmd_new_area: 'Buat area baru...',
            cmd_export_image: 'Ekspor gambar...',
            cmd_export_sql: 'Ekspor kode SQL...',
            cmd_grid_style: 'Ubah tata letak kisi...',
        },
        canvas_table: {
            more_column: 'kolom lainnya',
            more_columns: 'kolom lainnya',
            tooltip_table: 'Tabel',
            tooltip_indexes: 'Indeks',
            tooltip_enum: 'Enum',
            tooltip_default: 'Default',
            tooltip_generated: 'Dihasilkan',
            tooltip_check: 'Periksa',
        },
        m_export_code: {
            title: 'Ekspor kode {{db_engine}}',
            download_file: 'Unduh file',
            copy_code: 'Salin kode'
        },
        m_sign_in_remind: {
            title: 'Terima kasih telah mencoba DB Design',
            subtitle: 'Masuk atau daftar untuk menaikkan jumlah maksimum tabel, menyimpan diagram, dan membuka lebih banyak fitur.'
        },
        m_sign_in_restrict: {
            title: 'Masuk untuk melakukan lebih banyak di aplikasi',
            subtitle: 'Masuk atau daftar untuk meningkatkan batas tabel, menyimpan diagram, dan membuka lebih banyak fitur.'
        },
        m_new_diagram: {
            title: 'Diagram baru',
            subtitle: 'Pilih mesin basis data',
            open_diagram: 'Buka diagram',
            create_diagram: 'Buat diagram',
            no_workspace: 'Buat ruang kerja terlebih dahulu untuk mulai membuat diagram.',
            build_something_new: 'Mari membuat sesuatu yang baru',
            create_diagram_section: 'Buat diagram',
            clone_template_btn: 'Duplikat templat',
        },
        m_diagram_name: {
            enter_new_name: 'Masukkan nama diagram baru',
        },
        m_diagram_clone: {
            header: 'Duplikat diagram',
            copy_of_title: 'Salinan dari {{title}}',
        },
        m_diagram_rename: {
            header: 'Ganti nama diagram',
        },
        m_template_clone: {
            header: 'Buat diagram dari templat',
        },
        m_diagram_delete: {
            header: 'Hapus diagram',
            desc_prefix: 'Ini akan menghapus ',
        },
        m_diagram_archive: {
            header: 'Arsipkan diagram',
            desc_prefix: 'Ini akan mengarsipkan ',
        },
        m_diagram_restore: {
            header: 'Pulihkan diagram',
            desc_prefix: 'Ini akan memulihkan ',
        },
        m_diagram_import: {
            sql_name: 'Impor Kode SQL',
            dbml_name: 'Impor Kode DBML',
            placeholder: 'Kami ingin mendengar pendapat Anda!',
        },
        m_diagram_not_found: {
            header: 'Diagram tidak ditemukan',
            desc: 'Kami tidak dapat menemukan diagram yang Anda cari.',
            back_to_app: 'Kembali ke aplikasi',
        },
        m_diagram_share: {
            header: 'Bagikan diagram – {{title}}',
            owner_only_invite: 'Hanya pemilik yang dapat mengundang anggota baru',
            invited_to_workspace: 'Diundang ke ruang kerja',
            you: 'Anda',
            email_placeholder: 'Masukkan email',
            email_already_in_list: 'email sudah ada dalam daftar',
            will_be_invited_to_workspace: 'akan diundang ke ruang kerja',
        },
        m_invite_people: {
            header: 'Undang ke ruang kerja',
        },
        m_invite_revoke: {
            header: 'Hapus undangan',
            desc_prefix: 'Hapus undangan untuk ',
            desc_suffix: 'Undangan ini akan berhenti berfungsi.',
        },
        m_member_remove: {
            header: 'Hapus anggota',
            desc_prefix: 'Hapus ',
            desc_suffix: 'dari ruang kerja ini? Mereka akan kehilangan akses.',
        },
        m_template_details: {
            preview: 'Pratinjau',
            use_template: 'Gunakan templat',
        },
        m_workspace_create: {
            header: 'Buat ruang kerja baru',
            name_label: 'Nama',
            setup_config_label: 'Konfigurasi penyiapan',
            setup_config_value: 'Ruang kerja kosong',
            template_structure_label: 'Templat/Struktur',
            template_structure_value: 'Muat awal struktur',
            placeholder: 'Masukkan nama ruang kerja',
            create_button: 'Buat ruang kerja',
            creating: 'Membuat ruang kerja Anda...',
        },
        m_workspace_delete: {
            header: 'Hapus ruang kerja',
            desc_prefix: 'Ini akan menghapus secara permanen ',
            confirm_prefix: 'Ketik ',
            confirm_suffix: ' untuk mengonfirmasi.',
        },
        m_workspace_leave: {
            header: 'Keluar dari ruang kerja',
            desc_prefix: 'Ini akan mengeluarkan Anda dari ',
            desc_suffix: 'Anda perlu diundang kembali untuk bergabung lagi.',
        },
        m_workspace_menu: {
            manage_members: 'Kelola anggota',
            switch_workspace: 'Ganti ruang kerja',
            workspaces_label: 'Ruang kerja',
            create_workspace: 'Buat ruang kerja...',
            switching: 'Mengganti',
        },
        m_profile_menu: {
            profile: 'Profil',
            onboarding: 'Panduan awal',
        },
        m_pricing_limit: {
            admin_roles: { title: 'Tingkatkan kolaborasi Anda', description: 'Tingkatkan untuk membuka lebih banyak peran berbagi seperti Admin, Editor, Pemberi komentar, Penampil.' },
            workspaces: { title: 'Anda sedang berkembang pesat!', description: 'Tingkatkan untuk membuat dan mengelola lebih banyak ruang kerja untuk proyek dan tim Anda.' },
            workspaces_canvas: { title: 'Perluas ruang kerja Anda', description: 'Tingkatkan untuk membuat dan mengelola lebih banyak ruang kerja untuk proyek dan tim Anda.' },
            members: { title: 'Berkolaborasi dalam skala besar', description: 'Tingkatkan untuk mengajak lebih banyak anggota ke ruang kerja Anda dan berkolaborasi lebih efektif.' },
            diagrams: { title: 'Anda sedang berkembang pesat!', description: 'Tingkatkan untuk membuat lebih banyak diagram dan kembangkan proyek Anda dengan percaya diri.' },
            tables: { title: 'Buat tanpa batas', description: 'Tingkatkan untuk menambahkan lebih banyak tabel dan terus membangun diagram yang lebih besar dan lebih detail.' },
            columns: { title: 'Buat tanpa batas', description: 'Tingkatkan untuk menambahkan lebih banyak kolom dan terus membangun diagram yang lebih besar dan lebih detail.' },
            notes: { title: 'Buat tanpa batas', description: 'Tingkatkan untuk menambahkan lebih banyak catatan dan terus membangun diagram yang lebih besar dan lebih detail.' },
            areas: { title: 'Buat tanpa batas', description: 'Tingkatkan untuk menambahkan lebih banyak area dan terus membangun diagram yang lebih besar dan lebih detail.' },
            pens: { title: 'Buat tanpa batas', description: 'Tingkatkan untuk menambahkan lebih banyak gambar dan terus membangun diagram yang lebih besar dan lebih detail.' },
            default_title: 'Tingkatkan kolaborasi Anda',
            default_title_canvas: 'Tingkatkan performa Anda',
        },
        m_pricing_plans: {
            title: 'Tingkatkan paket Anda',
            subtitle: 'Anda selalu dapat meningkatkan atau menurunkan paket Anda nanti',
            monthly: 'Bulanan',
            annually: 'Tahunan',
            billed_annually: 'Ditagih tahunan',
            billed_monthly: 'Ditagih bulanan',
            free_for_everyone: 'Gratis untuk semua orang',
            current_plan: 'Paket saat ini',
            will_be_available_soon: 'Akan segera tersedia',
            price_period_user_month: '/pengguna/bulan',
            plan_free: {
                name: 'Gratis',
                button: 'Ubah paket',
                feature_realtime: 'Kolaborasi real-time',
                feature_members: '4 anggota / ruang kerja',
                feature_diagrams: '4 diagram / ruang kerja',
                feature_tables: '40 tabel / diagram',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'Semua fitur Gratis +',
                feature_members: 'Anggota tanpa batas',
                feature_diagrams: 'Diagram tanpa batas',
                feature_tables: 'Tabel tanpa batas',
                feature_history: 'Riwayat versi',
                feature_admin_roles: 'Peran admin',
            },
        },
        sidebar: {
            new: 'Baru',
            pinned_diagrams: 'Diagram yang disematkan',
            pin_hint: 'Sematkan diagram untuk melihatnya di sini',
            expand_sidebar: 'Perluas bilah sisi',
            home_aria: 'Beranda DB Design',
            open_menu: 'Buka menu',
            close_menu: 'Tutup menu',
            sidebar_menu_aria: 'Menu bilah sisi',
            plan_suffix: 'paket',
            diagram_options: 'Opsi diagram',
            pin: 'Sematkan',
            unpin: 'Lepas sematan',
            edit_details: 'Edit detail',
            see_details: 'Lihat detail',
            invite_people: 'Undang',
            collapse_sidebar: 'Ciutkan bilah sisi',
            close_sidebar: 'Tutup bilah sisi',
            open_sidebar: 'Buka bilah sisi',
            open_new_tab: 'Buka di tab baru',
        },
        focus_controls: {
            show_top: 'Tampilkan kontrol atas',
            hide_top: 'Sembunyikan kontrol atas',
            show_left: 'Tampilkan kontrol kiri',
            hide_left: 'Sembunyikan kontrol kiri',
        },
        m_keyboard_shortcuts: {
            title: 'Pintasan keyboard',
            general: {
                title1: 'Umum',
                title2: '',
                items: {
                    new_diagram: 'Buat diagram',
                    new_chat: 'Obrolan baru',
                    search: 'Aksi cepat atau pencarian',
                    preferences: 'Preferensi',
                    settings: 'Pengaturan',
                    keyboard_shortcuts: 'Pintasan keyboard',
                    toggle_sidebar: 'Alihkan bilah sisi',
                    toggle_theme: 'Alihkan tema',
                },
            },
            ctrl_left: {
                title1: 'Kontrol',
                title2: '(Kiri)',
                items: {
                    mouse_sel: 'Seleksi mouse / Mode tangan',
                    table: 'Tabel',
                    line: 'Garis',
                    area: 'Area',
                    note: 'Catatan',
                    comment: 'Komentar',
                    pen: 'Pena',
                    undo: 'Urungkan',
                    redo: 'Ulangi'
                },
            },
            ctrl_top_left: {
                title1: 'Kontrol',
                title2: '(Kiri atas)',
                items: {
                    export_img: 'Ekspor gambar',
                    search: 'Cari',
                    editor_panel: 'Panel editor',
                    zoom_to_fit: 'Sesuaikan ke layar',
                },
            },
            ctrl_bottom_right: {
                title1: 'Kontrol',
                title2: '(Kanan bawah)',
                items: {
                    minimap: 'Minimap',
                    full_screen: 'Layar penuh',
                    zoom_in: 'Perbesar',
                    zoom_out: 'Perkecil',
                    zoom_100: 'Zoom 100%'
                },
            },
            ctx_tab: {
                title1: 'Menu konteks',
                title2: '(Tabel)',
                items: {
                    dupl_tab: 'Duplikat tabel',
                    del_tab: 'Hapus tabel'
                },
            },
            ctx_del_tab: {
                title1: 'Menu konteks',
                title2: '(Hapus tabel)',
                items: {
                    yes: 'Ya',
                    no: 'Tidak'
                },
            },
            ctx_tab_col: {
                title1: 'Menu konteks',
                title2: '(Kolom tabel)',
                items: {
                    add_col_below: 'Tambah kolom di bawah',
                    focus_col_above: 'Fokus ke kolom di atas',
                    focus_col_below: 'Fokus ke kolom di bawah',
                    move_col_up: 'Pindahkan kolom ke atas',
                    move_col_down: 'Pindahkan kolom ke bawah',
                    dupl_col: 'Duplikat kolom',
                    del_col: 'Hapus kolom'
                },
            },
            ctx_line: {
                title1: 'Menu konteks',
                title2: '(Garis)',
                items: {
                    del_line: 'Hapus garis'
                },
            },
            ctx_area: {
                title1: 'Menu konteks',
                title2: '(Area)',
                items: {
                    dupl_area: 'Duplikat area',
                    del_area: 'Hapus area'
                },
            },
            ctx_multi: {
                title1: 'Menu konteks',
                title2: '(Multiseleksi)',
                items: {
                    select_all: 'Pilih semua elemen',
                    create_area_for_select_els: 'Buat area untuk elemen terpilih',
                    dupl_select_els: 'Duplikat elemen terpilih',
                    del_select_els: 'Hapus elemen terpilih'
                },
            },
        },
        t: {
            ctrl_left: {
                mouse_select: 'Seleksi mouse',
                table: 'Tabel',
                line: 'Garis',
                area: 'Area',
                note: 'Catatan',
                comment: 'Komentar',
                pen: 'Pena',
                undo: 'Urungkan',
                redo: 'Ulangi'
            },
            ctrl_top_left: {
                home: 'Beranda',
                name: 'Informasi diagram',
                editor: 'Editor',
                search: 'Pencarian',
                export: 'Opsi ekspor',
                view_mode: 'Mode tampilan',
                zoom_to_fit: 'Sesuaikan ke layar',
                grid: 'Tata letak kisi',
                history: 'Riwayat',
                main_menu: 'Menu utama',
                new_diagram: 'Diagram baru',
            },
            ctrl_top_right: {
                feature_req: 'Permintaan fitur',
                feedback: 'Kirim masukan',
                sign_in: 'Masuk',
                quick_share: 'Berbagi cepat'
            },
            ctrl_bottom_right: {
                full_screen: 'Layar penuh',
                minimap: 'Minimap',
                zoom_out: 'Perkecil',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Perbesar',
                info: 'Informasi & sumber daya'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Bawaan',
                        blue: 'Biru',
                        green: 'Hijau',
                        red: 'Merah',
                        purple: 'Ungu',
                        violet: 'Violet'
                    },
                    borders: {
                        none: 'Tidak ada',
                        solid: 'Solid',
                        dashed: 'Putus-putus',
                        dotted: 'Titik-titik'
                    },
                    color: 'Warna',
                    border: 'Garis tepi',
                    description: 'Deskripsi',
                    description_table_place: 'Deskripsi tabel',
                    description_column_place: 'Deskripsi kolom',
                    description_line_place: 'Deskripsi garis',
                    description_note_place: 'Deskripsi catatan',
                    description_area_place: 'Deskripsi area',
                    description_pen_place: 'Deskripsi pensil',
                    hide_menu: 'Sembunyikan menu',
                    show_menu: 'Tampilkan menu'
                },
                tab_col: {
                    add_col_below: 'Tambah kolom di bawah',
                    add_col_above: 'Tambah kolom di atas',
                    key: 'Key',
                    keys: {
                        none: 'Tidak ada',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Tidak ada',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Pindahkan kolom ke bawah',
                    move_col_up: 'Pindahkan kolom ke atas',
                    more_functions: 'Fungsi lainnya'
                },
                line: {
                    change_connects: 'Ubah konektor',
                    connects: {
                        empty: 'Kosong',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Saring elemen'
                },
                note: {
                    link_placeholder: 'Masukkan tautan',
                    link_apply: 'Tambah',
                    link_remove: 'Hapus',
                    link_edit: 'Edit',
                    link_needs_selection: 'Pilih teks untuk menautkan',
                    bulleted_list: 'Daftar',
                    numbered_list: 'Daftar bernomor',
                    font_style: 'Gaya font',
                    alignment: 'Perataan',
                    align_left: 'Rata kiri',
                    align_center: 'Rata tengah',
                    align_right: 'Rata kanan',
                    link: 'Tautan',
                    monospace: 'Monospace',
                    bold: 'Tebal',
                    italic: 'Miring',
                    underline: 'Garis bawah',
                    strikethrough: 'Coret',
                },
                multi: {
                    filter: 'Saring seleksi',
                    create_area: 'Buat area'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Penuh',
            keys_only: 'Hanya key',
            names_only: 'Hanya nama'
        },
        dropdown_ctrl_grid: {
            none: 'Tidak ada',
            lines: 'Garis',
            dots: 'Titik',
        },
        dropdown_ctrl_export: {
            export_img: 'Ekspor gambar',
            export_code: 'Ekspor kode SQL'
        },
        dropdown_ctrl_settings: {
            back_home: 'Kembali ke beranda',
            sign_in: 'Masuk',
            preferences: 'Preferensi',
            new_project: 'Proyek baru',
            import_diagram: 'Impor diagram',
            duplicate_diagram: 'Duplikat diagram',
            keyboard_shortcuts: 'Pintasan keyboard',
            languages: 'Bahasa',
            view: 'Tampilan',
            upgrade_plan: 'Tingkatkan paket',
            language: 'Bahasa',
            mouse_trackpad: 'Mouse atau trackpad',
            background_color: 'Warna latar belakang',
            grid_layout: 'Tata letak kisi',
            view_mode: 'Mode tampilan',
            show_align_lines: 'Tampilkan garis perata',
            show_members_cursors: 'Tampilkan kursor anggota',
            show_comments: 'Tampilkan komentar',
            undo_redo_controls: 'Kontrol urungkan/ulangi',
            show_scrollbars: 'Tampilkan bilah gulir',
            opt_auto: 'Otomatis',
            opt_trackpad: 'Trackpad',
            opt_mouse: 'Mouse',
            opt_default: 'Gelap (bawaan)',
            opt_gray: 'Abu-abu',
            opt_blue: 'Biru',
            opt_purple: 'Ungu',
            opt_violet: 'Violet',
            opt_green: 'Hijau',
            opt_red: 'Merah',
            opt_yellow: 'Kuning',
            opt_dots: 'Titik',
            opt_lines: 'Garis',
            opt_none: 'Tidak ada',
            opt_full: 'Penuh',
            opt_keys: 'Key',
            opt_names: 'Nama',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Umpan balik',
            keyboard_shortcuts: 'Pintasan keyboard',
            languages: 'Bahasa',
            homepage: 'Beranda'
        },
        n: {
            default: 'Memuat…',
            file_ready_to_download: 'File siap diunduh',
            code_copied: 'Kode telah disalin',
            link_copied: 'Tautan telah disalin',
            username_copied: 'Nama pengguna telah disalin',
            email_copied: 'Email telah disalin',
            please_enter_message: 'Silakan masukkan pesan',
            invalid_email: 'Alamat email tidak valid',
            note_link_unsupported_protocol: 'Jenis tautan tidak didukung. Gunakan https, http, mailto.',
            something_wrong_contact: 'Terjadi kesalahan. Silakan muat ulang halaman atau hubungi kami.',
            something_wrong: 'Terjadi kesalahan. Silakan muat ulang halaman.',
            sending: 'Mengirim…',
            request_sent: 'Permintaan telah dikirim. Terima kasih!',

            please_enter_email: 'Silakan masukkan alamat email',
            changing: 'Mengubah...',
            role_changed: 'Peran telah diubah',
            removing: 'Menghapus...',
            member_removed: 'Anggota telah dihapus',
            inviting: 'Mengundang...',
            invite_sent: 'Undangan telah dikirim',
            added_to_diagram: 'Ditambahkan ke diagram',
            invite_removed: 'Undangan telah dihapus',
            role_not_allowed_on_plan: 'Peran ini tidak tersedia di paket Anda. Tingkatkan untuk menetapkannya.',
            already_diagram_member: 'Orang ini sudah memiliki akses ke diagram.',
            cannot_invite_to_workspace: 'Minta admin ruang kerja untuk mengundang orang ini ke ruang kerja.',
            saving: 'Menyimpan...',
            saved: 'Tersimpan',
            diagram_renamed: 'Diagram telah diganti nama',
            diagram_updated: 'Diagram telah diperbarui',
            duplicating: 'Menduplikat...',
            diagram_duplicated: 'Diagram telah diduplikat',
            deleting: 'Menghapus...',
            diagram_archived: 'Diagram telah diarsipkan',
            diagram_deleted: 'Diagram telah dihapus',
            restoring: 'Memulihkan...',
            diagram_restored: 'Diagram telah dipulihkan',
            diagram_pinned: 'Diagram telah disematkan',
            diagram_unpinned: 'Sematan diagram telah dilepas',
            creating: 'Membuat...',
            diagram_created: 'Diagram telah dibuat',
            forbidden: 'Anda tidak memiliki akses ke itu.',
            invite_already_pending: 'Orang ini sudah memiliki undangan yang tertunda.',
            already_member: 'Sudah menjadi anggota ruang kerja',
            cannot_invite_self: 'Anda tidak dapat mengundang diri sendiri',
            workspace_not_found: 'Ruang kerja tidak ditemukan. Segarkan halaman dan coba lagi.',
            diagram_not_found: 'Diagram tidak ditemukan.',
            has_diagram_members: 'Diagram memiliki anggota aktif',
            seat_limit_reached: 'Anda telah mencapai batas kursi pada paket Anda. Tingkatkan untuk mengundang lebih banyak orang.',
            feature_not_in_plan: 'Fitur ini tidak termasuk dalam paket Anda saat ini.',
            subscription_expired: 'Langganan Anda telah berakhir. Perpanjang untuk terus menggunakannya.',
            subscription_inactive: 'Langganan Anda tidak aktif. Silakan perbarui informasi penagihan.',
            plan_limit_generic: 'Paket Anda tidak mengizinkan tindakan ini. Tingkatkan untuk melanjutkan.',

            // Auth / profile
            session_expired: 'Sesi Anda telah berakhir — silakan masuk kembali.',
            profile_updated: 'Profil telah diperbarui',
            profile_update_failed: 'Gagal memperbarui profil.',
            account_delete_failed: 'Gagal menghapus akun.',

            // Preferences
            couldnt_save: 'Tidak dapat menyimpan perubahan',
            try_again: 'Terjadi kesalahan. Silakan coba lagi.',

            // Workspace
            not_workspace_member: 'Anda bukan anggota ruang kerja tersebut.',
            workspace_switch_failed: 'Tidak dapat beralih ruang kerja. Silakan coba lagi.',
            workspace_create_failed: 'Tidak dapat membuat ruang kerja. Silakan coba lagi.',
            invalid_workspace_name: 'Nama ruang kerja tidak valid',
            workspace_updated: 'Ruang kerja telah diperbarui',
            workspace_update_failed: 'Tidak dapat memperbarui ruang kerja. Silakan coba lagi.',
            last_owner_cannot_leave: 'Anda adalah satu-satunya pemilik. Jadikan orang lain sebagai pemilik, atau hapus ruang kerja, sebelum keluar.',
            workspace_leave_failed: 'Tidak dapat keluar dari ruang kerja. Silakan coba lagi.',
            workspace_delete_forbidden: 'Hanya pemilik ruang kerja yang dapat menghapus ruang kerja ini.',
            workspace_has_active_billing: 'Batalkan langganan ruang kerja ini sebelum menghapusnya.',
            workspace_deleted: 'Ruang kerja telah dihapus',
            workspace_delete_failed: 'Tidak dapat menghapus ruang kerja. Silakan coba lagi.',
            member_remove_forbidden: 'Anda tidak memiliki izin untuk menghapus anggota ini.',
            member_remove_failed: 'Tidak dapat menghapus anggota. Silakan coba lagi.',
            cannot_remove_self: 'Gunakan "Keluar dari ruang kerja" untuk menghapus diri Anda sendiri.',
            cannot_remove_last_owner: 'Ruang kerja harus selalu memiliki pemilik. Jadikan orang lain sebagai pemilik terlebih dahulu.',
            invite_revoke_forbidden: 'Anda tidak memiliki izin untuk mencabut undangan ini.',
            invite_revoke_failed: 'Tidak dapat mencabut undangan. Silakan coba lagi.',
        },
        dashboard: {
            doc_title: 'Diagram',
            filter_all: 'Semua',
            filter_mydiagrams: 'Diagram saya',
            filter_shared: 'Dibagikan dengan saya',
            filter_archived: 'Diarsipkan',
            empty_all: 'Tidak ada diagram di "Semua diagram"',
            empty_mydiagrams: 'Tidak ada diagram di "Diagram saya"',
            empty_shared: 'Tidak ada diagram di "Dibagikan dengan saya"',
            empty_archived: 'Tidak ada diagram di "Diarsipkan"',
            example_diagram_badge: 'Diagram contoh',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'Kembali ke aplikasi',
                group_personal: 'Pribadi',
                group_organization: 'Organisasi',
                billing: 'Penagihan',
            },
            profile: {
                member_since: 'Anggota sejak {{date}}',
                general: 'Umum',
                email: 'Email',
                full_name: 'Nama lengkap',
                full_name_placeholder: 'Masukkan nama',
                account_protection: 'Perlindungan akun',
                mfa_label: 'Autentikasi multifaktor (MFA)',
                mfa_sub: 'Lapisan keamanan tambahan untuk akun · Segera hadir',
                mfa_enable: 'Aktifkan MFA',
                mfa_soon_tooltip: 'Akan segera tersedia',
                workspace_access: 'Akses ruang kerja',
                leave_workspace: 'Keluar dari ruang kerja',
                leave_workspace_sub: 'Menghapus diri Anda dari ruang kerja',
                leave_owner_tooltip: 'Alihkan kepemilikan sebelum keluar dari ruang kerja',
            },
            workspace: {
                header: 'Ruang kerja',
                general: 'Umum',
                name_label: 'Nama ruang kerja',
                name_placeholder: 'nama ruang kerja',
                stat_member_singular: 'Anggota',
                stat_member_plural: 'Anggota',
                stat_team_singular: 'Tim',
                stat_team_plural: 'Tim',
                members_section: 'Anggota',
                no_members: 'Tidak ada anggota',
                count_member_singular: 'anggota',
                count_member_plural: 'anggota',
                view_members_btn: 'Lihat anggota',
                danger_zone: 'Zona berbahaya',
                delete_workspace: 'Hapus ruang kerja',
                delete_workspace_sub: 'Ini akan menghapus ruang kerja secara permanen',
                delete_owner_only_tooltip: 'Hanya pemilik yang dapat menghapus ruang kerja',
                delete_cancel_sub_tooltip: 'Batalkan langganan Anda sebelum menghapus ruang kerja',
            },
            members: {
                header: 'Anggota',
                col_name: 'Nama',
                col_email: 'Email',
                col_role: 'Peran',
                col_joined: 'Bergabung',
                active_members: 'Anggota aktif',
                invited_section: 'Diundang',
                no_members: 'Belum ada anggota.',
                options_aria: 'Opsi',
                leave_workspace_item: 'Keluar dari ruang kerja...',
                remove_member_item: 'Hapus anggota...',
                remove_owner_only_tooltip: 'Hanya pemilik yang dapat menghapus anggota',
                remove_owner_row_tooltip: 'Pemilik tidak dapat dihapus dari ruang kerja',
                remove_invite_item: 'Hapus undangan...',
                role_invited_suffix: '{{role}} (Diundang)',
            },
            preferences: {
                section_general: 'Umum',
                section_diagram_defaults: 'Pengaturan diagram',
                section_diagram_views: 'Tampilan diagram',
                section_notifications: 'Notifikasi',
                theme_label: 'Tema antarmuka',
                theme_sub: 'Pilih skema warna antarmuka Anda',
                theme_dark: 'Gelap',
                theme_light: 'Terang',
                theme_system: 'Sistem',
                language_sub: 'Pilih bahasa antarmuka Anda',
                timezone_label: 'Zona waktu',
                timezone_sub: 'Pilih zona waktu Anda',
                timezone_options: {
                    honolulu: 'GMT-10:00 — Hawaii',
                    anchorage: 'GMT-09:00 — Alaska',
                    los_angeles: 'GMT-08:00 — Waktu Pasifik',
                    denver: 'GMT-07:00 — Waktu Pegunungan',
                    chicago: 'GMT-06:00 — Waktu Tengah',
                    new_york: 'GMT-05:00 — Waktu Timur',
                    caracas: 'GMT-04:00 — Caracas',
                    sao_paulo: 'GMT-03:00 — São Paulo',
                    azores: 'GMT-01:00 — Azores',
                    london: 'GMT+00:00 — London',
                    paris: 'GMT+01:00 — Paris, Berlin',
                    kyiv: 'GMT+02:00 — Kyiv, Athena',
                    istanbul: 'GMT+03:00 — Istanbul',
                    dubai: 'GMT+04:00 — Dubai',
                    karachi: 'GMT+05:00 — Karachi',
                    kolkata: 'GMT+05:30 — India',
                    dhaka: 'GMT+06:00 — Dhaka',
                    bangkok: 'GMT+07:00 — Bangkok, Jakarta',
                    shanghai: 'GMT+08:00 — Beijing, Singapura',
                    tokyo: 'GMT+09:00 — Tokyo, Seoul',
                    sydney: 'GMT+10:00 — Sydney',
                    auckland: 'GMT+12:00 — Auckland',
                },
                input_mode_sub: 'Pilih kontrol navigasi kanvas',
                background_sub: 'Pilih warna latar belakang untuk kanvas',
                grid_sub: 'Pilih tata letak kisi kanvas',
                show_align_lines_sub: 'Tampilkan garis saat meratakan objek',
                show_cursors_sub: 'Tampilkan kursor kolaborator lain',
                show_comments_sub: 'Tampilkan komentar di kanvas',
                show_scrollbars_sub: 'Tampilkan bilah gulir saat menavigasi kanvas',
                show_undo_redo_label: 'Tampilkan kontrol urungkan/ulangi',
                show_undo_redo_sub: 'Tampilkan kontrol untuk mengurungkan dan mengulangi perubahan',
                notif_shared_label: 'Diagram dibagikan dengan saya',
                notif_shared_sub: 'Saat seseorang membagikan diagram dengan saya',
                notif_mentions_label: 'Sebutan dalam komentar',
                notif_mentions_sub: 'Saat seseorang men-@sebut saya dalam komentar',
                notif_updates_label: 'Pembaruan produk',
                notif_updates_sub: 'Pembaruan bulanan tentang fitur dan peningkatan baru',
                show: 'Tampilkan',
                hide: 'Sembunyikan',
                on: 'Aktif',
                off: 'Nonaktif',
            },
            billing: {
                header: 'Penagihan',
                plan_free: 'Paket gratis',
                status_current: 'Saat ini',
                no_renewal_needed: 'Tidak perlu perpanjangan',
                payment_header: 'Pembayaran',
                no_payments: 'Tidak ada pembayaran',
                invoices_header: 'Faktur',
                no_invoices: 'Tidak ada faktur',
            },
            usage: {
                doc_title: 'Penggunaan',
                overview_title: 'Ringkasan',
                resource_limits_title: 'Batas sumber daya',
                label_diagrams: 'Diagram',
                label_tables: 'Tabel',
                label_areas: 'Area',
                label_notes: 'Catatan tempel',
                label_members: 'Anggota',
                label_tables_per_diagram: 'Tabel / Diagram',
                label_areas_per_diagram: 'Area / Diagram',
                label_notes_per_diagram: 'Catatan / Diagram',
                need_more_title: 'Butuh lebih banyak?',
                need_more_free: 'Tingkatkan ke Basic untuk lebih banyak diagram, riwayat versi, dan dukungan prioritas.',
                need_more_paid: 'Tingkatkan ke Professional untuk diagram, kursi tak terbatas, dan fitur lanjutan.',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'Halaman tidak ditemukan',
                dont_have_access_to_diagram: 'Anda tidak memiliki akses ke diagram ini atau diagram mungkin sudah tidak ada.',
                back_home: 'Kembali ke beranda'
            },
            error: {
                title: 'Error',
                link_is_invalid: 'Tautan ini tidak valid atau dimasukkan secara salah.',
                something_wrong: 'Terjadi kesalahan.',
                back_home: 'Kembali ke beranda',
                please_try_later: 'Silakan coba lagi nanti',
            },
            billing_success: {
                doc_title: 'Paket ditingkatkan',
                heading: 'Pembayaran berhasil',
                subtitle: 'Paket Anda telah berhasil ditingkatkan.',
                cta: 'Mulai mendesain',
            },
            email_verified: {
                doc_title: 'Email terverifikasi',
            },
            forgot_password: {
                doc_title: 'Lupa kata sandi',
            },
            password_updated: {
                doc_title: 'Kata sandi diperbarui',
            },
            reset_password: {
                doc_title: 'Atur ulang kata sandi',
            },
            check_email: {
                doc_title: 'Periksa email Anda',
            },
            sign_in: {
                doc_title: 'Masuk ke {{product}}',
            },
            sign_up: {
                doc_title: 'Daftar di {{product}}',
            },
        },
    },
};

export const idMeta = {
    lang_origin: 'Indonesia',
    lang_eng: 'Indonesian',
    lang_code: 'id',
};
